import { render } from "./UploadField.vue?vue&type=template&id=3ce05b7e&scoped=true"
import script from "./UploadField.vue?vue&type=script&lang=js"
export * from "./UploadField.vue?vue&type=script&lang=js"

import "./UploadField.vue?vue&type=style&index=0&id=3ce05b7e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce05b7e"]])

export default __exports__